<template>
  <div class="ma-4">
    <ClientNav />
    <div class="ma-2 mt-10">
      <AddBMDialog ref="bm-dialog" @save-item="save" @update-item="update" :isAuditorRole="isAuditorRole" />
      <div class="ma-1">
        <v-alert
          dense
          border="top"
          colored-border
          type="info"
          color="primary"
          elevation="2"
        >
          <span class="bm-info">
            <v-row align="center" no-gutters>
              <strong>Bowel Movement (BM)</strong> <br />
              <v-spacer></v-spacer>
              <v-col class="shrink">
                <v-btn
                  color="primary"
                  outlined
                  x-small
                  @click="showInfo1 = !showInfo1"
                >
                  {{ showInfo1 ? "hide" : "show" }}
                </v-btn>
              </v-col>
            </v-row>
            <v-expand-transition>
              <div v-if="showInfo1" class="text-body-2">
                When the Client has a BM, record it on the table and sign your
                initials within the same box. Also include the Type, according
                to the Bristol Stool Chart(i.e. BM-3). If there is no BM, mark a
                slash “/” and sign your initials within the same box. After 3
                days (72 hours) pass without there being a BM (or passing fewer
                than 3 stools in a week), it is considered constipation. This
                time frame may be shorter according to individual needs. For
                those with a BM Protocol from their Healthcare Provider, follow
                those instructions. Otherwise, contact the Medical Manager for
                instructions on how to proceed.
              </div>
            </v-expand-transition>
          </span>
        </v-alert>
        <v-alert
          dense
          border="top"
          colored-border
          type="info"
          color="primary"
          elevation="2"
        >co
          <span class="bm-info">
            <v-row align="center" no-gutters>
              <strong>Prevention of Constipation</strong> <br />
              <v-spacer></v-spacer>
              <v-col class="shrink">
                <v-btn
                  color="primary"
                  outlined
                  x-small
                  @click="showInfo2 = !showInfo2"
                >
                  {{ showInfo2 ? "hide" : "show" }}
                </v-btn>
              </v-col>
            </v-row>
            <v-expand-transition>
              <div v-if="showInfo2" class="text-body-2">
                Natural approaches for constipation include drinking prune,
                apple or pear juice. Make sure that the Client drinks at least 8
                cups (64 fl oz) of water daily. After 2 days (48 hours) pass
                without there being a BM, give 1/2-1 cup (4-8 fluidounces) of
                one of the above juices. Also contact the Medical Manager. On
                the back of this BM Tracking Sheet, record when juice is given
                and circle the box indicating when it was given.Also record any
                abnormal color changes. Normal stool coloris brown, but can
                range from light yellow to dark brown (almost black). Contact
                the Medical Manager immediately if stoolis an abnormal color
                (i.e.red, black, pale, yellow, green).
              </div>
            </v-expand-transition>
          </span>
        </v-alert>
      </div>

      <v-card class="pa-0 mb-3" outlined flat>
        <v-card-actions>
          <v-btn-toggle>
            <v-btn @click="togglePage('list')">
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-btn>
            <v-btn @click="togglePage('chart')">
              <v-icon>mdi-card-text-outline</v-icon>
            </v-btn>
          </v-btn-toggle>
          <v-spacer></v-spacer>
          <v-btn
            small
            color="success"
            dark
            @click="generateReport"
            :loading="isLoading"
          >
            download report
            <template v-slot:loader>
              <span>generating...</span>
            </template>
          </v-btn>
        </v-card-actions>
      </v-card>

      <div class="tscroll" v-if="page === 'chart'">
        <table>
          <thead class="table-head">
            <tr>
              <th class="table-head-th"></th>
              <th class="table-head-th" v-for="(date, i) in dates" :key="i">
                {{ i + 1 }}
              </th>
            </tr>
          </thead>
          <tbody class="main-body">
            <template>
              <tr v-for="row in charts" :key="row.date">
                <td class="main-body--schedule">
                  <div class="main-body-td--content-schedule text-center">
                    {{ row.scheduled }}
                  </div>
                </td>
                <td
                  class="main-body--info"
                  v-for="cell in row.charts"
                  :key="cell.id"
                  :bgcolor="
                    userId !== cell.records.staffId &&
                    cell.records.isSelectBM === 'absent'
                      ? 'gray'
                      : cell.records.type !== '' &&
                        cell.records.isSelectBM !== 'false' &&
                        userId !== cell.records.staffId
                      ? 'gray'
                      : (cell.records.type !== '' &&
                          (cell.records.isSelectBM !== 'false' ||
                            cell.records.isSelectBM === 'absent') &&
                          userId === cell.records.staffId) ||
                        ((cell.records.isSelectBM === 'false' ||
                          cell.records.isSelectBM === 'absent') &&
                          userId === cell.records.staffId)
                      ? 'green'
                      : cell.records.isSelectBM === 'false' &&
                        userId !== cell.records.staffId
                      ? 'gray'
                      : ''
                  "
                  @click="selectCell(row, cell)"
                >
                  <div class="main-body-td--content text-center">
                    <span
                      v-if="cell.records.isSelectBM == 'true'"
                      class="white--text"
                    >
                      {{ cell.records.bmType }} <br />
                      <span class="text-caption">{{ cell.records.staff }}</span>
                    </span>

                    <span v-if="cell.records.isSelectBM == 'false'">
                      <v-icon class="white--text">mdi-slash-forward</v-icon>
                      <br />
                      <span class="text-caption white--text">{{
                        cell.records.staff
                      }}</span>
                    </span>

                    <span v-if="cell.records.isSelectBM == 'absent'">
                      <span class="white--text">A</span>
                      <br />
                      <span class="text-caption white--text">{{
                        cell.records.staff
                      }}</span>
                    </span>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div v-else>
        <ChartList @fetch-chart-data="fetch" />
      </div>

    </div>
  </div>
</template>

<script>
/*eslint-disable */
import AddBMDialog from "../chart/AddBMDialog";
import ClientNav from "@/components/ClientNav";
import ChartList from "./ChartList";

import moment from "moment";
import { mapActions, mapState } from "vuex";

import { bmPDF } from "./bm.pdf";

export default {
  components: {
    ClientNav,
    ChartList,
    AddBMDialog,
  },
  data() {
    return {
      selectedCell: null,
      dialog: true,
      newValue: "",
      charts: [],
      scheduledTime: ["Early AM", "AM", "Noon", "Early PM", "PM", "Late PM"],
      dates: [],
      clientId: "",
      isLoading: false,
      scheduled: "",
      scheduledDate: "",
      BMData: [],
      bmChartId: "",
      showInfo1: true,
      showInfo2: true,
      userId: "",
      scheduleInitials: {
        "Early AM": "em",
        AM: "a",
        Noon: "n",
        PM: "p",
        "Early PM": "ep",
        "Late PM": "lp",
      },
      page: "chart",
    };
  },

  computed: {
    // ...mapGetters({
    //   getClientBMChart: "bowelMovementCharts/getClientBMChart",
    // }),

    ...mapState("users", ["user"]),

    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    },

    showBMInfo() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.showInfo1 = false;
        this.showInfo2 = false;
      } else {
        this.showInfo1 = true;
        this.showInfo2 = true;
      }
    },
  },

  watch: {
    showBMInfo(val) {
      return val;
    },
  },

  created() {
    this.fetch();
    this.userId = localStorage.getItem("userID");

    if (this.$route.query.bmId === undefined) {
      this.$router.back();
    }
  },
  methods: {
    ...mapActions({
      getItemById: "bowelMovementCharts/getItemById",
      createItem: "bowelMovementCharts/createItem",
      updateItem: "bowelMovementCharts/updateItem",
      deleteItem: "bowelMovementCharts/deleteItem",
      getBM: "bowelMovements/getItemById",
    }),

    selectCell(row, cell) {
      this.selectedCell = cell;
      this.scheduled = row.scheduled;
      this.scheduledDate = cell.date;
      this.bmChartId = cell.records._id;

      if (cell.records.staffId === "") {
        this.$refs["bm-dialog"].show();
      }

      if (cell.records.staffId === this.userId) {
        this.$refs["bm-dialog"].show();
        this.$refs["bm-dialog"].populateData(cell.records);
      }

      if (cell.records.staffId != this.userId) return;
    },

    async fetch() {
      try {
        this.isLoading = true;
        this.clientId = this.$route.params.clientID;
        const response = await this.getItemById(this.$route.query.bmId);
        this.BMData = response.data;
        console.log(this.BMData);
        this.getChartData(this.BMData);
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },

    async getChartData(chartItem) {
      const bowelMovement = await this.getBM(this.$route.query.bmId);
      let openenDate = bowelMovement.data.openedDate;

      const startDay = moment(openenDate).startOf("month");
      const endDay = moment(openenDate).endOf("month");

      let datesArray = [];

      for (
        let currentDate = startDay;
        currentDate.isSameOrBefore(endDay);
        currentDate.add(1, "days")
      ) {
        datesArray.push(currentDate.format("YYYY-MM-DD"));
      }

      let data = [];

      const dates = datesArray;

      this.dates = datesArray;

      for (let i = 0; i < this.scheduledTime.length; i++) {
        const scheduled = this.scheduledTime[i];
        const charts = [];

        for (let j = 0; j < dates.length; j++) {
          const date = dates[j];

          const chart = {
            date,
            records: {
              staffId: "",
              bmType: "",
              isSelectBM: null,
              bmId: "",
              _id: "",
              staff: "",
              type: "",
              scheduled: scheduled,
            },
          };

          const record = chartItem.find(
            (item) =>
              item.scheduledDate === date && item.scheduled === scheduled
          );

          if (record) {
            let type = record?.type;
            let initials = record.createdBy
              .split(" ")
              .map((n) => n.charAt(0).toUpperCase())
              .join("");
            chart.records.bmType = `BM-${type?.substring(5, 6)}`;
            chart.records.isSelectBM = record.isSelectBM;
            chart.records.staffId = record.staffId;
            chart.records.bmId = record.bmId;
            chart.records._id = record._id;
            chart.records.staff = initials;
            chart.records.type = record.type;
          }

          charts.push(chart);
        }

        const chartData = {
          scheduled,
          charts,
        };

        data.push(chartData);
      }

      this.charts = data;
    },
    async save(data) {
      const req_body = {
        ...data,
        scheduled: this.scheduled,
        scheduledDate: this.scheduledDate,
        clientId: this.clientId,
        bmId: this.$route.query.bmId,
      };
      console.log(req_body);
      try {
        await this.createItem(req_body);
        this.fetch();
      } catch (error) {
        console.log(error);
      }
    },

    async update(data) {
      const req_body = {
        ...data,
        scheduled: this.scheduled,
        scheduledDate: this.scheduledDate,
        clientId: this.clientId,
        bmId: this.$route.query.bmId,
      };
      console.log(req_body);
      try {
        await this.updateItem({ data: req_body, id: this.bmChartId });
        this.fetch();
      } catch (error) {
        console.log(error);
      }
    },

    async generateReport() {
      this.isLoading = true;

      const companyLogo =  this.user?.Company[0]?.Logo 

      const response = await this.getBM(this.$route.query.bmId);
      const bm = response.data;

      const additionalPdfData = {
        program: bm.clientId.Program.join(", "),
        name: bm.clientId.Name,
        month: bm.month,
      };

      try {
        let data = [];
        const formUrl = require("../../../../assets/pdf/CRX-bm-chart.pdf");
        for (let i = 0; i < this.charts.length; i++) {
          let chartData = this.charts[i].charts;
          for (let j = 0; j < chartData.length; j++) {
            let chartRecords = chartData[j].records;
            data.push(
              this.generatePdfChartData(chartRecords, chartRecords.scheduled, j)
            );
          }
        }
        await bmPDF(formUrl, data, additionalPdfData, companyLogo);
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },

    generatePdfChartData(chartRecords, scheduledTime, iterator) {
      let data = [];
      let BMchartData = {};

      if (chartRecords.scheduled === scheduledTime) {
        // staff
        BMchartData[
          `${this.scheduleInitials[scheduledTime]}-staff-${iterator}`
        ] = false
          ? chartRecords.staff
          : chartRecords.isSelectBM === null || chartRecords.isSelectBM === ""
          ? ""
          : chartRecords.isSelectBM == "true"
          ? chartRecords.staff
          : "";

        // BM staff
        BMchartData[
          `${this.scheduleInitials[scheduledTime]}-bmStaff-${iterator}`
        ] = chartRecords.isSelectBM == "true" ? "" : chartRecords.staff;

        // type
        BMchartData[
          `${this.scheduleInitials[scheduledTime]}-type-${iterator}`
        ] = true
          ? chartRecords.isSelectBM == "true"
            ? `BM-${chartRecords.type.substring(5, 6)}`
            : ""
          : chartRecords.isSelectBM === null || chartRecords.isSelectBM === ""
          ? ""
          : chartRecords.isSelectBM == "true"
          ? ""
          : chartRecords.type;

        // is BM
        BMchartData[
          `${this.scheduleInitials[scheduledTime]}-isBM-${iterator}`
        ] = false
          ? "/"
          : chartRecords.isSelectBM === null || chartRecords.isSelectBM === ""
          ? ""
          : chartRecords.isSelectBM == "true"
          ? ""
          : chartRecords.isSelectBM == "absent"
          ? "A"
          : "/";

        data = BMchartData;
      }
      return data;
    },

    togglePage(page) {
      this.page = page;
    },
  },
};
</script>

<style scoped>
.tscroll {
  overflow-x: auto;
  margin-bottom: 10px;
}

.tscroll table td:first-child {
  position: sticky;
  left: 0;
}

.tscroll table,
thead,
tr,
th:first-child {
  position: sticky;
  left: 0;
}

.tscroll td,
.tscroll th {
  border-bottom: 1px dashed black;
  border-right: 1px dashed black;
}

.main-body {
  background-color: rgb(255, 255, 255);
}

.main-body--schedule {
  background-color: rgb(230, 228, 226);
}

.main-body-td--content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 7vh;
  min-width: 7vh;
}

.main-body-td--content-schedule {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 8vh;
  min-width: 8vh;
}

.table-head-th {
  border-top: 1px dashed black;
  background-color: rgb(230, 228, 226);
}

.main-body--info {
  transition: 0.3s;
}

.main-body--info:hover {
  background-color: gray;
  cursor: pointer;
}
</style>
